import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Own constants/actions/components
import { banners } from 'services/selectors/exclusivity-banner';
import { resSubmitShopping } from 'services/selectors/submit-shopping';
import { items } from 'services/selectors/shopping-cart';
import StepsLineComponent from 'components/steps-line';
import incompleteRequest from 'assets/incomplete-request.svg';
import ResumenTicketMobile from './resumen-ticket-mobile';
import ResumenTicket from './resumen-ticket';

const ErrorContainer = () => {
  const response = useSelector(resSubmitShopping);
  const itemsCart = useSelector(items);
  const disabledShop = true;
  const banner = useSelector(banners);
  const { results } = banner !== undefined ? banner : {};

  return (
    <>
      <ResumenTicketMobile resumen={itemsCart} disabled={disabledShop} />
      <Container fluid className="bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <StepsLineComponent itemActive={2} />
            </Col>
          </Row>
          <Row className="justify-content-center py-60">
            <Col lg={9} className="text-center">
              <h2>¡Lo sentimos!</h2>
              <p className="py-30 text-tangaroa">
                {response.message}
              </p>
              <img src={incompleteRequest} alt="shopping-cart-error" />
              <p className="py-30 text-text-tangaroa">
                { response.status === 409 ? (
                  'Haz clic en el botón de ‘Inicio’ para adquirir otras Experiencias.'
                ) : 'Haz clic en el botón de ‘Reintentar’ para continuar navegando en el sitio.'}
              </p>
              <Link to="/" className="btn btn-primary">
                { response.status === 409 ? 'Inicio' : 'Reintentar'}
              </Link>
            </Col>
            <Col lg={3}>
              <ResumenTicket resumen={itemsCart} sticky={false} disabled={disabledShop} />
              {
                results !== undefined ? (
                  <div className="my-15 position-relative">
                    <div className="text-center">
                      <a href={results.buttonLink} className="btn btn-primary btn-absolute-bottom">
                        { results.buttonText }
                      </a>
                    </div>
                    <img
                      className="banner-error"
                      src={results.image}
                      alt="promo"
                      width="100%" />
                  </div>
                ) : ''
              }
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default ErrorContainer;
